import {SagaIterator} from 'redux-saga';
import {select} from 'typed-redux-saga';

import {State} from 'app/setup';

/**
 * Loads the current animal-list version string.
 *
 * @param id Animal list id.
 * @returns The current list version.
 */
export function* getAnimalListVersion(id: number): SagaIterator<string> {
    const animalLists = yield* select((state: State) => state.mating.animalLists);
    const animalList = animalLists
        .findIn(y => y.id === id)
        .orCrash('animalLists not available');

    return animalList.version;
}
